import React from "react";
import { Link } from 'gatsby';

import BrakesInString from '../BrakesInString'

export const FooterTemplate = ( {data, siteMetadata} ) => {
  const { socialLinks } = data;
  const { mailchimpTracker } = siteMetadata;

  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="footer__inner">
          <div className="footer__main">
            <div className="footer__main-item">
              <div>
                <BrakesInString text={data.title}/>
              </div>
            </div>
            <div className="footer__main-item">
              {mailchimpTracker && mailchimpTracker !== '' && (
                <div dangerouslySetInnerHTML={{ __html: mailchimpTracker }} />
              )}
            </div>
            <div className="footer__main-item">
              {socialLinks.length > 0 && (
                <div className="social">
                  <ul className="social__links">
                    {socialLinks.map(socialLink => (
                      <li key={socialLink.linkURL} className="social__item">
                        <a
                          className="social__link"
                          href={socialLink.linkURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className="footer-socialLinkIcon"
                            src={socialLink.image}
                            alt={socialLink.imageAlt}
                            width="47"
                            height="47"
                          />
                          {socialLink.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="footer__bottom">
            <div className="footer__bottom-item">
              <div className="footer__copy">
                2016 – 2025 | © Hackolade | All rights reserved.
              </div>
            </div>
            <div className="footer__bottom-item">
              <div className="footer__bottom-links">
                <div className="footer__bottom-link">
                  <Link to={data.termsConditions.url}>{data.termsConditions.label}</Link>
                </div>
                <div className="footer__bottom-link">
                  <Link to={data.privacyPolicy.url}>{data.privacyPolicy.label}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </footer>


  );
};

const Footer = props => {
  if (!props.data) {
    return null;
  }
  const data = props.data.edges[0].node.frontmatter;
  const siteMetadata = props.siteMetadata;

  return <FooterTemplate data={data} siteMetadata={siteMetadata} />;
};

export { Footer };
